// extracted by mini-css-extract-plugin
export var beefSammy = "BeefSammy-module--beef-sammy--b74b4";
export var bottom = "BeefSammy-module--bottom--5b4ba";
export var open = "BeefSammy-module--open--87834";
export var top = "BeefSammy-module--top--c9c76";